<template>
    <b-container fluid>
        <b-overlay :show="customLoading" rounded="sm">
            <iq-card>
                <template v-slot:body>
                    <b-row>
                        <b-col md="10" class="m-auto">
                            <table class="table table-sm">
                                <tr>
                                    <th>{{ $t('globalTrans.fiscal_year') }}</th>
                                    <td>{{getFiscalYear(formData.fiscal_year_id)}}</td>
                                    <th>{{$t('trainer_trainee.circular_memo_no')}}</th>
                                    <td>{{getCircularMemo(formData.circular_id)}}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('trainer_trainee.training_title')}}</th>
                                    <td>{{getTraining(formData.training_name_id)}}</td>
                                    <th>{{ $t('trainer_trainee.batch')}}</th>
                                    <td>{{formData.batch_id ? getBatch(formData.batch_id) : ''}}</td>
                                </tr>
                                <tr>
                                    <th>{{ $t('elearning_config.application_date')}}</th>
                                    <td>{{ formData.apply_date | dateFormat }}</td>
                                    <th></th>
                                    <td></td>
                                </tr>
                            </table>
                        </b-col>
                        <b-col class="pb-2">
                            <b-button variant="primary" @click="pdfExport" class="mr-2 float-right">
                                {{  $t('globalTrans.export_pdf') }}
                            </b-button>
                        </b-col>
                    </b-row>
                    <table class="table table-sm table-bordered small">
                        <thead style="background-color: #e0e0de">
                            <tr style="background-color: #e0e0de">
                                <th>{{ $t('elearning_config.name')}}</th>
                                <th>{{ $t('elearning_config.designation') }}</th>
                                <th>{{ $t('trainer_trainee.org_name') }}</th>
                                <th>{{ $t('trainer_trainee.total_day') }}</th>
                                <th>{{ $t('trainer_trainee.allowance') }}</th>
                                <th>{{ $t('trainer_trainee.ta_da') }}</th>
                                <th>{{ $t('trainer_trainee.sub_total') }}</th>
                                <th>{{ $t('trainer_trainee.deduction') }}</th>
                                <th>{{ $t('trainer_trainee.total') }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <b-tr v-for="(item, index) in listData" :key="index">
                                <td>{{currentLocale === 'en'? item.name_en : item.name_bn}}</td>
                                <td>{{ item.other_designation ? item.other_designation : (currentLocale === 'en'? item.designation : item.designation_bn) }}</td>
                                <td>{{ currentLocale === 'en'? item.organization :  item.organization_bn}} </td>
                                <td>
                                    {{$n(item.total_class)}}
                                </td>
                                <td>
                                    {{$n(item.allowance_amount)}}
                                </td>
                                <td>
                                    {{$n(item.ta_da_amount)}}
                                </td>
                                <td>
                                    {{$n(item.sub_total)}}
                                </td>
                                <td>
                                    {{$n(item.deduction_amount)}}
                                </td>
                                <td>
                                    {{$n(item.total)}}
                                </td>
                            </b-tr>
                        </tbody>
                    </table>
                </template>
            </iq-card>
        </b-overlay>
    </b-container>
</template>
<script>
    import RestApi, { trainingElearningServiceBaseUrl } from '@/config/api_config'
    import {
        traineeBatchListApi,
        allowanceUpdateApi,
        allowanceStoreApi
    } from '../../api/routes'
    import flatpickr from 'flatpickr'
    import ExportPdf from './export-pdf'

    export default {
        props: ['item'],
        components: {
        },
        data () {
            return {
                saveBtnName: this.id ? this.$t('globalTrans.update') : this.$t('globalTrans.save'),
                formData: {
                    fiscal_year_id: 0,
                    circular_id: 0,
                    training_name_id: 0,
                    batch_id: 0,
                    allowance_amount: 0,
                    ta_da_amount: 0,
                    apply_date: null
                },
                circularMemoList: [],
                trainingTitleList: [],
                listData: [],
                customLoading: false
            }
        },
        mounted () {
            flatpickr('#apply_date', { minDate: 'today' })
        },
        computed: {
            fiscalYearList: function () {
                return this.$store.state.commonObj.fiscalYearList.map(item => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: item.value, text: item.text_bn }
                    } else {
                        return { value: item.value, text: item.text_en }
                    }
                })
            },
            batchList: function () {
                return this.$store.state.TrainingElearning.commonObj.batchList.filter(item => item.status === 1).map(item => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: item.value, text: item.text_bn }
                    } else {
                        return { value: item.value, text: item.text_en }
                    }
                })
            },
            currentLocale () {
                return this.$i18n.locale
            }
        },
        watch: {
            'formData.fiscal_year_id': function (newVal, oldVal) {
                if (!this.item) {
                    this.formData.circular_id = 0
                    this.formData.training_name_id = 0
                }
                this.circularMemoList = this.getMomoList(newVal)
                this.trainingTitleList = []
            },
            'formData.circular_id': function (newVal, oldVal) {
                if (!this.item) {
                    this.formData.training_name_id = 0
                }
                this.trainingTitleList = this.getTrainingTitle(newVal)
            },
            'formData.training_name_id': function (newVal, oldVal) {
                if (newVal > 0) {
                    this.loadData()
                }
            },
            'formData.allowance_amount': function (newVal, oldVal) {
                this.listData.forEach((element, index) => {
                    this.listData[index].allowance_amount = parseFloat(newVal).toFixed(2)
                    this.Calculation(index)
                })
            },
            'formData.ta_da_amount': function (newVal, oldVal) {
                this.listData.forEach((element, index) => {
                    this.listData[index].ta_da_amount = parseFloat(newVal).toFixed(2)
                    this.Calculation(index)
                })
            }
        },
        created () {
            if (this.item) {
                this.formData.fiscal_year_id = this.item.fiscal_year_id
                this.formData.circular_id = this.item.circular_publication_id
                this.formData.training_name_id = this.item.training_title_id
                this.formData.batch_id = this.item.batch_id
                this.formData.allowance_amount = this.item.allowance_amount
                this.formData.ta_da_amount = this.item.ta_da_amount
                this.formData.ta_da_amount = this.item.ta_da_amount
                this.formData.apply_date = this.item.application_date
                // this.listData = this.formatdata(this.item.details)
                /* const tmp = this.getTrainerSelectionData()
                 this.formData = Object.assign(tmp, { trainerList: [] }) */
            }
        },
        methods: {
            getFiscalYear (fiscalYearId) {
                const fiscalObj = this.$store.state.commonObj.fiscalYearList.find(item => item.value === fiscalYearId)
                if (this.$i18n.locale === 'bn') {
                    return fiscalObj.text_bn
                } else {
                    return fiscalObj.text_en
                }
            },
            getCircularMemo (circularMemoId) {
                const circularObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
                if (this.$i18n.locale === 'bn') {
                    return circularObj.text_bn
                } else {
                    return circularObj.text_en
                }
            },
            getTraining (trainingId) {
                const trainingObj = this.$store.state.TrainingElearning.commonObj.trainingNameList.find(item => item.value === trainingId)
                if (this.$i18n.locale === 'bn') {
                    return trainingObj.text_bn
                } else {
                    return trainingObj.text_en
                }
            },
            getBatch (id) {
                const trainingObj = this.$store.state.TrainingElearning.commonObj.batchList.find(item => item.value === id)
                if (this.$i18n.locale === 'bn') {
                    return trainingObj.text_bn
                } else {
                    return trainingObj.text_en
                }
            },
            ChangeCheck (index, type, target) {
                if (type === 1) {
                    this.listData[index].allowance_amount = target
                }
                if (type === 2) {
                    this.listData[index].ta_da_amount = target
                }
                if (type === 5) {
                    this.listData[index].total_class = target
                }
                if (type === 3) {
                    this.listData[index].deduction_amount = target
                }
                this.Calculation(index)
            },
            Calculation (index) {
                const classAmount = this.listData[index].total_class
                const honorarium = parseFloat(this.listData[index].allowance_amount * classAmount)
                const tadaamount = parseFloat(this.listData[index].ta_da_amount)
                const deduction = this.listData[index].deduction_amount
                const sub = honorarium + tadaamount
                const total = sub - deduction
                this.listData[index].sub_total = parseFloat(sub).toFixed(2)
                this.listData[index].total = parseFloat(total).toFixed(2)
            },
            async storeTrainer () {
                this.customLoading = true
                this.$store.dispatch('mutateCommonProperties', { loading: true })
                let result = null
                const loadinState = { loading: false, listReload: true }
                this.formData.details = this.listData
                if (this.item) {
                    result = await RestApi.putData(trainingElearningServiceBaseUrl, `${allowanceUpdateApi}/${this.item.id}`, this.formData)
                } else {
                    result = await RestApi.postData(trainingElearningServiceBaseUrl, allowanceStoreApi, this.formData)
                }
                this.$store.dispatch('mutateCommonProperties', loadinState)

                if (result.warning) {
                    this.customLoading = false
                    this.$toast.error({
                        title: 'warning',
                        message: result.message
                    })
                    return
                }

                if (result.success) {
                    this.$store.commit('TrainingElearning/mutateCommonObj', { hasDropdownLoaded: false })
                    this.$toast.success({
                        title: 'Success',
                        message: this.id ? 'Data updated successfully' : 'Data save successfully',
                        color: '#D6E09B'
                    })
                    this.$bvModal.hide('modal-4')
                } else {
                    this.$refs.form.setErrors(result.errors)
                    this.$toast.error({
                        title: 'Error',
                        message: 'Operation failed! Please, try again.'
                    })
                }
            },
            getMomoList (fiscalYearId) {
                return this.$store.state.TrainingElearning.commonObj.circularMemoList.filter(item => item.fiscal_year_id === fiscalYearId).map(item => {
                    if (this.$i18n.locale === 'bn') {
                        return { value: item.value, text: item.text_bn }
                    } else {
                        return { value: item.value, text: item.text_en }
                    }
                })
            },
            getTrainingTitle (circularMemoId) {
                const trainingObj = this.$store.state.TrainingElearning.commonObj.circularMemoList.find(item => item.value === circularMemoId)
                if (trainingObj !== undefined) {
                    return this.$store.state.TrainingElearning.commonObj.trainingNameList.filter(item => item.status === 1 && item.value === trainingObj.training_title_id).map(item => {
                        if (this.$i18n.locale === 'bn') {
                            return { value: item.value, text: item.text_bn }
                        } else {
                            return { value: item.value, text: item.text_en }
                        }
                    })
                }
            },
            loadData () {
                this.customLoading = true
                RestApi.getData(trainingElearningServiceBaseUrl, traineeBatchListApi, this.formData).then(response => {
                    if (response.success) {
                        if (this.item) {
                            const info = []
                            response.data.forEach((element, index) => {
                                this.item.details.forEach((element2, index2) => {
                                    if (element.trainee_main_id === element2.trainee_main_id) {
                                        info.push({
                                            id: element2.trainee_main_id,
                                            trainee_id: element.trainee_main_id,
                                            name_en: element.name_en,
                                            name_bn: element.name_bn,
                                            designation: element.designation,
                                            designation_bn: element.designation_bn,
                                            organization: element.organization,
                                            organization_bn: element.organization_bn,
                                            contact_no: element.contact_no,
                                            total_class: element2.total_class,
                                            allowance_amount: element2.allowance_amount,
                                            ta_da_amount: element2.ta_da_amount,
                                            sub_total: parseFloat(element2.allowance_amount) + parseFloat(element2.ta_da_amount),
                                            deduction_amount: element2.deduction_amount,
                                            total: element2.total_amount
                                        })
                                    }
                                })
                            })
                            this.listData = info
                        } else {
                            this.listData = response.data
                        }
                    }
                    this.customLoading = false
                })
            },
          pdfExport () {
          const reportTitle = this.$t('trainer_trainee.allowance') + ' ' + this.$t('globalTrans.details')
          ExportPdf.exportPdfDetails(trainingElearningServiceBaseUrl, 'config/report-heading/detail', 4, reportTitle, this.formData, this, this.listData)
        }
        }
    }
</script>
